import { useEffect, useRef, useState } from 'react'
import CreateButton from '../../../../Partials/Layouts/CRUDs/CRUDHeader/CreateButton/CreateButton';
import CRUDTable from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTable';
import CRUDTableHeader from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableHeader/CRUDTableHeader';
import CRUDth from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableHeader/CRUDth/CRUDth';
import ViewButton from '../../../../Partials/Layouts/CRUDs/CRUDButtons/ViewButton/ViewButton';
import EditButton from '../../../../Partials/Layouts/CRUDs/CRUDButtons/EditButton/EditButton';
import DeleteButton from '../../../../Partials/Layouts/CRUDs/CRUDButtons/DeleteButton/DeleteButton';
import ShortTextCell from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableCells/ShortTextCell/ShortTextCell';
import CRUDTableRow from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableRow/CRUDTableRow';
import Modal from '../../../../Partials/Elements/Modal/Modal';
import useAxiosInstance from '../../../../../Utilities/Hooks/useAxiosInstance';
import DeleteItem from '../../../../Partials/Layouts/DeleteItem/DeleteItem';
import { PAIREDPRODUCT_API } from '../../../../../Utilities/APIs/APIs';
import ViewPairedProduct from './ViewPairedProduct';
import CreatePairedProduct from './CreatePairedProduct';
import UpdatePairedProduct from './UpdatePairedProduct';
import { useParams } from 'react-router-dom';

function PairedProducts() {

  const [pairedProducts, setPairedProducts] = useState(null)
  const screenHeaerRef = useRef()
  const [screenHeaderHeight, setScreenHeaderHeight] = useState(0);

  useEffect(() => {
    let screenHeaderHeight = screenHeaerRef.current.clientHeight;
    setScreenHeaderHeight(screenHeaderHeight)
  }, [screenHeaerRef]);

  const [showCreateForm, setShowCreateForm] = useState(false);
  const [showViewSection, setShowViewSection] = useState(false);
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [showDeleteSection, setShowDeleteSection] = useState(false)
  const [toggleFetch, setToggleFetch] = useState(false)

  const [targetID, setTargetID] = useState(null)
  const axiosInstance = useAxiosInstance()
  const {productID} = useParams()

  useEffect(() => {

    async function fetchAndSetPairedProducts() {
      const { data } = await axiosInstance.get(PAIREDPRODUCT_API + 'getPairedProductsByProduct/' + productID)
      setPairedProducts(data)
    }
    fetchAndSetPairedProducts()

  }, [toggleFetch, axiosInstance, productID])

  function triggerFetch() {
    setToggleFetch(prevState => !prevState)
  }
  return (
    <>
      <div className='screen_header' ref={screenHeaerRef}>
        <h1 className='screen_heading'>Paired Products ({pairedProducts?.length}  in total)</h1>
        <CreateButton
          screenTopicSingular={'Paired Products'}
          setShowCreateForm={setShowCreateForm}
        />
      </div>
      <CRUDTable screenHeaderHeight={screenHeaderHeight}>
        <CRUDTableHeader>
          <CRUDth th='Main Product' />
          <CRUDth th='Paired product' />
          <CRUDth th='Action' />

        </CRUDTableHeader>
        <tbody>
          {
            pairedProducts?.map(pairedProduct =>
              <CRUDTableRow key={pairedProduct._id}>
                <ShortTextCell text={pairedProduct?.product1?.name} />
                <ShortTextCell text={pairedProduct?.product2?.name} />
                <td>
                  <div className="action_buttons_wrapper">
                    <div className="action_buttons">
                      <ViewButton
                        setShowViewSection={setShowViewSection}
                        targetID={pairedProduct._id}
                        setTargetID={setTargetID}
                      />

                      <EditButton
                        setShowUpdateForm={setShowUpdateForm}
                        targetID={pairedProduct._id}
                        setTargetID={setTargetID}
                      />

                      <DeleteButton
                        setShowDeleteSection={setShowDeleteSection}
                        targetID={pairedProduct._id}
                        setTargetID={setTargetID}
                      />
                    </div>
                  </div>
                </td>
              </CRUDTableRow>

            )
          }
        </tbody>
      </CRUDTable>
      {
        showCreateForm &&
        <Modal
          extraClass={'small'}
          modalHeading={`Add Paired Product`}
          setShowModalContent={setShowCreateForm}
        >
          <CreatePairedProduct
          productID={productID}
            triggerFetch={triggerFetch}
            setShowCreateForm={setShowCreateForm}
          />
        </Modal>
      }
      {
        showUpdateForm &&
        <Modal
          extraClass={'small'}
          modalHeading={`Update Paired Product`}
          setShowModalContent={setShowUpdateForm}
        >
          <UpdatePairedProduct
          productID={productID}
            triggerFetch={triggerFetch}
            targetID={targetID}
            setShowUpdateForm={setShowUpdateForm}
          />
        </Modal>
      }
      {
        showViewSection &&
        <Modal
          extraClass={'small'}
          modalHeading={`View Paired Product`}
          setShowModalContent={setShowViewSection}
        >
          <ViewPairedProduct
            targetID={targetID}
          />
        </Modal>
      }
      {
        showDeleteSection &&
        <Modal
          extraClass={'small'}
          modalHeading={`Delete Paired Product`}
          setShowModalContent={setShowDeleteSection}
        >
          <DeleteItem
            api={PAIREDPRODUCT_API}
            triggerFetch={triggerFetch}
            targetID={targetID}
            setShowDeleteItem={setShowDeleteSection}
          />
        </Modal>
      }
    </>
  )
}

export default PairedProducts